import {BaseError} from 'make-error';

export class BaseException<T = any> extends BaseError {
    public message: string;
    public name: string;
    public stack: string;
    public data?: T;
    public innerException?: BaseException | BaseError;

    constructor(name: string,
                message: string,
                data: T = {} as T,
                stack?: string) {
        super(message);
        this.name = name;
        this.data = data;

        if (stack) {
            this.stack = stack;
        } else if (this.stack) {
            const stackFrames = this.stack.split('\n');
            stackFrames.splice(0, 3);
            stackFrames.unshift(`Unhandled ${this.name}: ${this.message}`);
            this.stack = stackFrames.join('\n');
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/server-communications/exceptions/base-exception.ts